<template>
    <Dialog 
        :header="'Thông báo'"
        :visible.sync="display"
        :contentStyle="{overflow: 'visible'}"
        :style="{width: width + 'vw'}"
        :class="'popup-confirm dialog-header-custom'"
        :modal="true"
        :closable="false"
        >
        <template #header>
            <slot name="header">
                <span  class="p-dialog-title" >Thông báo</span>
            </slot>
            <div class="p-dialog-header-icons">
                <button class="p-dialog-header-icon p-dialog-header-close p-link" @click="closePopup" >
                    <span class="p-dialog-header-close-icon pi pi-times"></span>
                </button>
            </div>
        </template>
        <div class="p-fluid">
            <div class="box-body">
                <div class="header">
                    <img v-if="this.messages.count_error > 0 || (messages.count_exist > 0 && popup_type == 'serial_number')" :src="'../../../assets/images/u566.png'"/>
                    <img v-else-if="messages.count_verify > 0 || messages.count_exist > 0" :src="'../../../assets/images/u579.png'"/>
                    <span v-if="this.messages.count_error > 0 || (messages.count_exist > 0 && popup_type == 'serial_number')" class="error">LỖI</span>
                    <span v-else-if="messages.count_verify > 0 || messages.count_exist > 0">XÁC NHẬN</span>
                </div>
                <ul>
                    <li class="success" v-if="((popup_type == 'product' || popup_type == 'organization') && messages.count_verify > 0) || (popup_type == 'serial_number' && messages.count_production > 0)">{{ rowVerify }}</li>
                    <li class="error" v-if="messages.count_error > 0 || (popup_type == 'serial_number' && messages.count_not_production > 0)"> {{ rowError }}</li>
                    <li class="error"  v-else-if="messages.count_exist > 0"> {{ rowExists }}</li>
                </ul>
                <p class="error" v-if="(popup_type == 'product' || popup_type == 'organization') && messages.count_error == 0 &&  messages.count_exist > 0">Bạn có đồng ý import dữ liệu hợp lệ và ghi đè dữ liệu trùng không?</p>
                <p class="error" v-else-if="(popup_type == 'product' || popup_type == 'organization') && messages.count_error == 0 && messages.count_verify > 0">Bạn có đồng ý import dữ liệu hợp lệ không?</p>


                <div class="box-download">
                    <span class="icon-custom" @click="exportExcel">
                        <img :src="'../../../assets/images/u569.png'"/>
                        <img :src="'../../../assets/images/u570.png'"/>
                    </span>
                </div>
                <div class="box-note"> 
                    <p :class="popup_type == 'serial_number'  &&  messages.count_verify > 0 ? 'relative' : ''" v-if="messages.count_error > 0 || (messages.count_exist > 0 && popup_type == 'serial_number')" >Vui lòng tải file để kiểm tra dữ liệu không hợp lệ</p>
                    <p :class="(popup_type == 'serial_number'  &&  messages.count_verify > 0 ? 'relative' : '')" v-else-if="messages.count_exist > 0 || messages.count_verify > 0">Vui lòng tải file kiểm và xác nhận để tiếp tục quá trình import dữ liệu</p>
                    <p :class="'txt-error ' + (popup_type == 'serial_number'  &&  messages.count_verify > 0 ? 'relative ' + (messages.count_not_production > 0 ? 'not-relative' : '') : '')" v-if="popup_type == 'serial_number'  &&  messages.count_not_production > 0 && messages.count_error == 0">(Lưu ý: Sau khi "Đồng ý" thì không thể thay đổi Trạng thái sản xuất của Serial number)</p>
                </div>
            </div>
        </div>
        <template #footer>
            <Button  v-if="((popup_type == 'product' || popup_type == 'organization') && messages.count_error == 0 && (messages.count_exist > 0 || messages.count_verify > 0)) || (popup_type == 'serial_number' && messages.count_verify > 0 && messages.count_error == 0)" label="Đồng ý" @click="acceptPopup()" />
            <Button  v-if="((messages.count_exist > 0 || (messages.count_error == 0 && messages.count_verify > 0)) && popup_type == 'serial_number') || messages.count_error > 0 || ((popup_type == 'product' || popup_type == 'organization') && messages.count_error == 0 && (messages.count_exist > 0 || messages.count_verify > 0))" label="Huỷ" class="p-button-danger"  @click="closePopup"/>
        </template>
   </Dialog>
</template>

<script>

export default {
  props: {
    displayDialog: Boolean,
    messages: Object,
    textExist: {
        type: String,
        default: ' dữ liệu trùng {0} đã tồn tại'
    },
    popup_type: {
        type: String,
        default: 'product'
    },
    width: {
        type: Number,
        default: 40
    }
  },
  data() {
    return {
        display: false,
        rowVerify: '',
        rowExists: '',
        rowError: '',
        componentKey: 0
    }
  },
  created () {
    this.display = this.displayDialog;
    if (this.messages  != undefined  && this.messages != null && Object.keys(this.messages).length) {
        if (this.popup_type == 'product' || this.popup_type == 'organization') {
            var textMessage = (this.popup_type == 'product') ? this.textExist.replace('{0}', 'sản phẩm') : (this.popup_type == 'organization' ? this.textExist.replace('{0}', 'đơn vị') : '');
            this.rowVerify =  this.messages.count_verify > 0 ?  this.messages.count_verify + ' dòng dữ liệu hợp lệ' : '';
            this.rowExists =  this.messages.count_exist > 0 ?  this.messages.count_exist + ' ' + textMessage : '';
            this.rowError =  this.messages.count_error > 0 ?  this.messages.count_error + '  dòng dữ liệu không hợp lệ' : '';
        } else if (this.popup_type == 'serial_number') {
            if (this.messages.count_error > 0) {
                this.rowError =  this.messages.count_error > 0 ?  this.messages.count_error + '  dòng dữ liệu không hợp lệ' : '';
                this.rowVerify =  this.messages.count_verify > 0 ?  this.messages.count_verify + ' dòng dữ liệu hợp lệ' : '';
            } else  {
                this.rowVerify =  this.messages.count_production > 0 ?  this.messages.count_production + '  serial number đã sản xuất' : '';
                this.rowError =  this.messages.count_not_production > 0 ?  this.messages.count_not_production + '  serial number không sản xuất' : '';
                this.rowExists =  this.messages.count_exist > 0 ?  this.messages.count_exist + ' dòng serial number không đúng' : '';
            }
        }
    }
  },
  methods: {
    acceptPopup() {
        this.$emit('accept');
    },
    closePopup() {
        this.$emit('cancel');
    },
    exportExcel() {
        this.$emit('export-excel');
    }
  }
}
</script>

<style lang="scss">
.popup-confirm{
    .box-body{ padding: 0 15px;
        .header{ align-items: center;  display: flex;
            span{margin-left: 15px;font-size: 18px;  color: #0066FF; font-weight: bold;
                &.error{color: #f00;}
            }
        }
        ul {
            li {
                &.success{ color: #00CC00;}
            }
        }
        .box-download{ float: left; min-height: 80px;align-items: baseline; cursor: pointer;
            span{ position: relative;  word-wrap: break-word; font-weight: 400; font-style: italic; color: #666666; cursor: pointer;
                img{ position: relative; cursor: pointer;
                    &:last-child{position: absolute; top: 0; left: 10px;}
                }
                &:last-child{cursor: auto;}   
            }
        }
        .box-note{width: calc(100% - 80px);  float: left; margin-left: 15px; min-height: 80px; position: relative;
            p{word-wrap: break-word; font-weight: 400; font-style: italic; color: #666666; margin-bottom: 0px; font-size: 14px;
                &:last-child{margin: 0; position: absolute; bottom: 0;}
                &.relative{position: relative;
                    &:last-child{margin: 0; position: absolute; bottom: 0;}
                    &.not-relative{bottom: auto;}
                }
            }

        }
    }
    .p-dialog-footer{text-align: center; border: 0 none;
        button{width: 120px; margin-right: 50px;
            &:last-child{margin: 0;}
        }
    }
}
</style>